<template>
  <div>
    <HeaderYahooSmartphonePurchase/>
    <section class="container mt-5">
      <slot />
    </section>
    <Footer />
  </div>
</template>
